import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

const ResponsePage = () => {
  const { testId,testcode } = useParams(); // Extract testId from the route
  const rollNo = localStorage.getItem("rollno"); // Get rollNo from localStorage
  const [questions, setQuestions] = useState([]); // Store question objects
  const [isLoading, setIsLoading] = useState(true);

  // Local mapping of question texts
  const questionTextMapping = {};

 useEffect(() => {
  const fetchData = async () => {
    try {
      
      const apiEndpoint = `https://testresult.omegacareerinstitute.com/admin/welcome/get_test_response?testId=${testId}&rollno=${rollNo}`;
      const response = await fetch(apiEndpoint);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

     const data = await response.json();

if (data) {
  const marks = data.response ? JSON.parse(data.response) : {};
  const answers = data.ans ? JSON.parse(data.ans) : {};

  const questionList = Object.entries(marks)
    .filter(([key]) => key.startsWith("Q"))
    .map(([key, value]) => ({
      text: key,
      status:
        value === 4
          ? "right"
          : value === -1
          ? "wrong"
          : "left",
      ans: answers[key] || ""
    }));

  setQuestions(questionList);
}

    } catch (error) {
      console.error("Error fetching API data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchData();
}, [testId, rollNo]);


  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!questions.length) {
    return <div>No data available for the given test ID and roll number.</div>;
  }

  // Calculate counts based on the question statuses
  const leftCount = questions.filter((q) => q.status === "left").length;
  const rightCount = questions.filter((q) => q.status === "right").length;
  const wrongCount = questions.filter((q) => q.status === "wrong").length;

  return (
    <Container className="mt-5">
      <h2 className="text-center">OMR Test Result {testcode}</h2>
        <Card className="mt-4">
        <Card.Body>
  <Row className="text-center">

    {/* Left */}
    <Col>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            backgroundColor: "#f0f0f0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "5px",
            border: "1px solid #c6bebeff",
          }}
        >
          <span style={{ fontSize: "16px", color: "gray" }}></span>
        </div>
        <h5 style={{ margin: 0 }}>Left: {leftCount}</h5>
      </div>
    </Col>

    {/* Right */}
    <Col>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            backgroundColor: "lightgreen",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "5px",
            border: "1px solid #69c769",
          }}
        >
          <span style={{ fontSize: "16px", color: "green" }}></span>
        </div>
        <h5 style={{ margin: 0 }}>Right: {rightCount}</h5>
      </div>
    </Col>

    {/* Wrong */}
    <Col>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            backgroundColor: "salmon",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "5px",
            border: "1px solid #d96c6c",
          }}
        >
          <span style={{ fontSize: "16px", color: "red" }}></span>
        </div>
        <h5 style={{ margin: 0 }}>Wrong: {wrongCount}</h5>
      </div>
    </Col>

  </Row>
</Card.Body>

      </Card>
     <Row className="mt-4 justify-content-center">
  {questions.map((question, index) => (
    <Col
      key={index}
      xs={6}
      sm={4}
      md={3}
      lg={2}
      className="d-flex justify-content-center mb-4"
      style={{ maxWidth: "20%" }} // Forces 5 per row
    >
     <Link
  to={`/question-detail?rollno=${rollNo}&testId=${testId}&qno=${index + 1}&ans=${encodeURIComponent(
    question.ans || ""
  )}`}
  style={{ textDecoration: "none" }}
>

      <div
        style={{
          width: "33px",
          height: "33px",
          borderRadius: "50%",
          backgroundColor:
            question.status === "left"
              ? "#f0f0f0"
              : question.status === "right"
              ? "lightgreen"
              : "salmon",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "2px solid #ccc",
          cursor: "pointer",
         
          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <h5
          style={{
            margin: 0,
            fontWeight: "bold",
             fontSize: "12px",
            color:
              question.status === "left"
                ? "gray"
                : question.status === "right"
                ? "green"
                : "#e8e8e8",
          }}
        >
          {index + 1}
        </h5>
      </div></Link>
    </Col>
  ))}
</Row>

    
    </Container>
  );
};

export default ResponsePage;
